import React from 'react';
import store from 'redux/store';
import { setPreventLecturePageNavigation } from 'redux/actions/lecture-pages';
import { PreventNavigationReason } from 'redux/schemas/models/lecture-page';

const usePreventLecturePageNavigation = (getShouldPrevent: () => boolean, reason: PreventNavigationReason = PreventNavigationReason.SAVING_IN_PROGRESS) => {
  const shouldPrevent = getShouldPrevent();

  React.useEffect(() => {
    store.dispatch(setPreventLecturePageNavigation(shouldPrevent ? reason : null));
  }, [shouldPrevent, reason]);

  React.useEffect(() => () => {
    store.dispatch(setPreventLecturePageNavigation(null));
  }, []);
};

export const useAngularPreventLecturePageNavigation = (scope: angular.IScope, getShouldPrevent: () => boolean, reason: PreventNavigationReason = PreventNavigationReason.SAVING_IN_PROGRESS) => {
  let firstTime = true;

  scope.$watch(getShouldPrevent, (newValue) => {
    if (!firstTime) {
      store.dispatch(setPreventLecturePageNavigation(newValue ? reason : null));
    } else {
      firstTime = false;
    }
  });

  scope.$on('$destroy', () => {
    store.dispatch(setPreventLecturePageNavigation(null));
  });
};

export default usePreventLecturePageNavigation;
